export const getTemplatePickerModalSteps = (t) => [
    {
        target: '[data-tour="tpm-modal"]',
        placement: 'center',
        title: t('tour.templatePickerModal.step-welcome-title'),
        content: t('tour.templatePickerModal.step-welcome-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="tpm-intolerances"]',
        title: t('tour.templatePickerModal.step-intolerances-title'),
        content: t('tour.templatePickerModal.step-intolerances-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="tpm-illnesses"]',
        title: t('tour.templatePickerModal.step-illnesses-title'),
        content: t('tour.templatePickerModal.step-illnesses-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="tpm-caloric"]',
        title: t('tour.templatePickerModal.step-caloric-title'),
        content: t('tour.templatePickerModal.step-caloric-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="tpm-list"]',
        placement: 'top',
        title: t('tour.templatePickerModal.step-list-title'),
        content: t('tour.templatePickerModal.step-list-content'),
        disableBeacon: true,
    },
];
